import { gql } from '@apollo/client';

export const ADD_MEMBER_TO_GROUP = gql`
	mutation addMemberToGroup($input: CrewMemberGroupAssignmentInput!) {
		assignCrewMemberToGroups(input: $input) {
			id
			fullName
			driverCard
			currentHomeBase {
				city {
					name
				}
			}
			phone
		}
	}
`;
